import {UseQueryOptions, useQuery} from '@tanstack/react-query'
import {useGetProductApiMethod} from 'api/useGetProductApiMethod'
import {Ventrata} from 'types'

export const useGetProductQuery = (
  productId: string,
  options?: Omit<UseQueryOptions<Ventrata.Product>, 'queryKey' | 'queryFn'>
) => {
  const getProduct = useGetProductApiMethod()

  return useQuery({
    queryKey: ['getProduct', productId],
    queryFn: () => getProduct(productId),
    ...options,
  })
}
